module.exports = __webpack_public_path__ + "img/item6-4.01aea57a.jpg";